/**
 * card-images.dev.js
 * Lightbox PhotoSwipe pour les sections UGC (card-images avec data-ugc="true").
 * Réutilise window.FoxTheme.PhotoSwipeLightbox déjà chargé par le thème natif.
 */

document.addEventListener('DOMContentLoaded', () => {
  initAllUgcLightboxes();
});

function initAllUgcLightboxes() {
  document.querySelectorAll('card-images[data-ugc="true"]').forEach((container) => {
    initUgcLightbox(container);
  });
}

function initUgcLightbox(container) {
  if (!window.FoxTheme?.PhotoSwipeLightbox || !window.FoxTheme?.PhotoSwipe) return;

  // Exclure les slides dupliqués par Swiper (mode loop)
  const triggers = [...container.querySelectorAll('.ugc-lightbox-trigger')].filter(
    (el) => !el.closest('.swiper-slide-duplicate')
  );
  if (!triggers.length) return;

  const dataSource = triggers.map((trigger) => ({
    src: trigger.dataset.ugcSrc,
    width: parseInt(trigger.dataset.ugcWidth) || 1500,
    height: parseInt(trigger.dataset.ugcHeight) || 1500,
    msrc: trigger.querySelector('img')?.src,
  }));

  const lightbox = new window.FoxTheme.PhotoSwipeLightbox({
    dataSource,
    pswpModule: window.FoxTheme.PhotoSwipe,
    bgOpacity: 1,
    arrowPrev: false,
    arrowNext: false,
    zoom: false,
    close: false,
    counter: false,
    preloader: false,
  });

  lightbox.on('uiRegister', () => {
    lightbox.pswp.ui.registerElement({
      name: 'prev',
      ariaLabel: 'Image précédente',
      order: 1,
      isButton: true,
      html: '<svg class="pswp-icon-prev rtl-flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50 L 65,10 L 60,0 Z"></path></svg>',
      onClick: () => lightbox.pswp.prev(),
    });
    lightbox.pswp.ui.registerElement({
      name: 'next',
      ariaLabel: 'Image suivante',
      order: 3,
      isButton: true,
      html: '<svg class="pswp-icon-next flip-x" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 65,90 L 25,50 L 65,10 L 60,0 Z"></path></svg>',
      onClick: () => lightbox.pswp.next(),
    });
    lightbox.pswp.ui.registerElement({
      name: 'close-zoom',
      ariaLabel: 'Fermer',
      order: 2,
      isButton: true,
      html: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
      onClick: () => lightbox.pswp.close(),
    });
  });

  lightbox.init();

  // Délégation sur le container — couvre les slides originaux ET les clones Swiper.
  // Utilise pointerup au lieu de click pour contourner preventClicks de Swiper.
  let pointerStartX = 0;
  let pointerStartY = 0;

  container.addEventListener('pointerdown', (e) => {
    pointerStartX = e.clientX;
    pointerStartY = e.clientY;
  });

  container.addEventListener('pointerup', (e) => {
    const dx = Math.abs(e.clientX - pointerStartX);
    const dy = Math.abs(e.clientY - pointerStartY);
    if (dx > 8 || dy > 8) return; // drag, pas un tap

    const trigger = e.target.closest('.ugc-lightbox-trigger');
    if (!trigger) return;

    const index = dataSource.findIndex((item) => item.src === trigger.dataset.ugcSrc);
    if (index !== -1) lightbox.loadAndOpen(index);
  });

  // Accessibilité clavier — uniquement sur les slides originaux
  triggers.forEach((trigger) => {
    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const index = dataSource.findIndex((item) => item.src === trigger.dataset.ugcSrc);
        if (index !== -1) lightbox.loadAndOpen(index);
      }
    });
  });
}
